import { Purchases } from "../constants/Purchases";
import { IProduct, ITpackage } from "../entities/product/types";
import Validator from "../validators/Validator";
import UrlService from "./UrlService";

export default class TariffPackageService {

  static urlParams: any;

  static init() {
    this.urlParams = UrlService.getParamsFromUrlOnLoadPage();
  }

  static getTpByTpId(product: IProduct, tpId: number, purchase: string): ITpackage {
    const tariffPackages: ITpackage[] = this.getTariffPackagesByPurchase(product, purchase);

    const tariffPackage: any = tariffPackages?.find((tariffPackage:ITpackage) => {
      return tariffPackage.id === Number(tpId);
    });

    return Validator.isObject(tariffPackage) && Validator.checkIfObjectHasPropKeys(tariffPackage) ?
      tariffPackage : Validator.isArray(product.assignedTariffPackage?.prices[purchase]) &&
      Validator.checkIfArrayHasItems(product.assignedTariffPackage?.prices[purchase]) ? product.assignedTariffPackage :
        Validator.isArray(tariffPackages) && Validator.checkIfArrayHasItems(tariffPackages) ?
          tariffPackages[0] : product.assignedTariffPackage;
  }

  static getTariffPackagesByPurchase(product: IProduct, purchase: string): ITpackage[] {
    return product.tariffPackages?.filter((tariffPackage: any) =>
      Validator.isArray(tariffPackage.prices[purchase]) && Validator.checkIfArrayHasItems(tariffPackage.prices[purchase])
    );
  }

  static getTariffPackagesWithPriceByInstallments(tariffPackages: any, type: string, subscription: string, installments:number): ITpackage[] {
    if (type === Purchases.SUBSIDY) {
      return tariffPackages.filter((tariffPackage: any) =>
        Number(tariffPackage[subscription]) > 0 && tariffPackage.prices[type].some((item: any) => item.contractDuration === installments));
    }

    return tariffPackages.filter((tariffPackage: any) =>
      Number(tariffPackage[subscription]) > 0 && tariffPackage.prices[type].some((item: any) => item.installments === installments));
  }

  static getFirstTariffPackageByPurchase(product: IProduct, purchase: string): ITpackage {
    return this.getTariffPackagesByPurchase(product, purchase)[0];
  }

}
